import * as Sentry from '@sentry/vue'

export const resilientImport = (webpackPromise, pushRoute = null) => {
  return webpackPromise
    .then(module => {
      return module
    })
    .catch(e => {
      Sentry.captureMessage('Automatically resolving chunk load problem', scope => {
        scope.setExtra('originalError', e.stack)
        scope.setExtra('pushRoute', pushRoute)
      })
      Sentry.close(0)
      if (pushRoute !== null && pushRoute !== undefined) {
        console.warn(`navigating to /${pushRoute}`)
        window.location.href = `/${pushRoute}`
      } else {
        window.location.reload()
      }
    })
}
